/* @flow */

import featureRouter from 'src/shared/app/feature/featureRouter';
import { createFeatureDecisions } from 'src/shared/app/feature/factory/featureFactory';

export default function useFeatureDecisions(): Object {
  const obj = createFeatureDecisions(featureRouter);

  return {
    isSelfCheckInEnabled: obj.isSelfCheckInEnabled(),
    isHelpEnabled: obj.isHelpEnabled(),
    isSlackIntegrationEnabled: obj.isSlackIntegrationEnabled(),
    areNewProfileQuestionsEnabled: obj.areNewProfileQuestionsEnabled(),
    areEmailNotificationsEnabled: obj.areEmailNotificationsEnabled(),
    isSignupEnabled: obj.isSignupEnabled(),
    isVideoCallEnabled: obj.isVideoCallEnabled(),
  };
}
